/*
 * Copyright © 2026 MS IMAGES. All rights reserved.
 * Proprietary and confidential — unauthorized copying, distribution, or use
 * of this file, via any medium, is strictly prohibited. See LICENSE.
 */

/**
 * React Query hook for fetching the current user's accessible locations.
 * Used by transaction forms to populate location pickers.
 */

import { useQuery } from '@tanstack/react-query';
import { orgUsersService } from '../services/org-users.service';
import type { LocationSummaryDto } from '../services/org-users.service';
import type { ApiError } from '@/services/api/types';

export const myLocationKeys = {
  all: ['venta', 'my-locations'] as const,
};

export function useMyLocations() {
  return useQuery<LocationSummaryDto[], ApiError>({
    queryKey: myLocationKeys.all,
    queryFn: () => orgUsersService.getMyLocations(),
    staleTime: 5 * 60_000, // 5 minutes — locations don't change often
  });
}
